import React from 'react'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox from '../../../../components/Cards/DetailsBox'

const Plan = ({ plan }) => (
  <DetailsBox
    title="Plan"
    rows={[
      { label: 'Patient Outcome', value: plan.ptOutcome },
      ...(plan.ptOutcome === 'Handed over to Ambulance Crew'
        ? [
            {
              label: 'Company / NHS Trust',
              value: plan.ambulanceHandoverTrust,
            },
            {
              label: 'Ambulance Crew Callsign',
              value: plan.ambulanceHandoverCallsign,
            },
            {
              label: 'CAD Number',
              value: plan.ambulanceHandoverCAD,
            },
          ]
        : []),
      { label: 'Notes', value: plan.planNotes },
      { label: 'Destination', value: plan.destinationName },
      { label: 'Destination Type', value: plan.destinationType },
      { label: 'Transport Type', value: plan.transportType },
      {
        label: 'Safety Features Used',
        value: plan.transportSafetyFeatures.join(', '),
      },
      { label: 'Advice Given', value: plan.adviceGiven },
      { label: 'Leaflets', value: plan.leafletsProvided.join(', ') },
    ]}
  />
)

export default Plan
